<template>
  <van-popup
    :show="webModalStore.visible"
    position="right"
    class="web-modal-popup"
    :style="{ height: '100%' }"
    :close-on-click-overlay="false"
    @update:show="handleShowChange"
    @closed="handleClosed"
  >
    <div class="web-modal-page">
      <AppNavBar
        :title="pageTitle"
        :fixed="false"
        :placeholder="false"
        :background-color="webModalStore.navBackgroundColor"
        :auto-back="false"
        @click-left="webModalStore.close()"
      />
      <div class="web-modal-page__body">
        <iframe
          v-if="webModalStore.url"
          class="web-modal-page__iframe"
          :src="webModalStore.url"
        />
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWebModalStore } from '@/stores/web-modal';

const { t } = useI18n();
const webModalStore = useWebModalStore();
const pageTitle = computed(() => webModalStore.title || t('common.userAgreement'));

function handleShowChange(value) {
  if (!value) {
    webModalStore.close();
  }
}

function handleClosed() {
  webModalStore.reset();
}
</script>

<style lang="scss" scoped>
.web-modal-popup {
  width: var(--app-shell-width);
  background: #fff;
}

.web-modal-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
}

.web-modal-page__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: #fff;
}

.web-modal-page > :deep(.van-nav-bar) {
  flex: 0 0 auto;
  width: 100%;
}

.web-modal-page__iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>
